import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path = "customer-agent";

export default class CustomerAgentApi extends BaseAPI {

  static list(params: any): Promise<any> {
    return this.api.get(path, { params: { ...params } }).then((res) => res);
  }
  static listCustomerNew(params: any): Promise<AxiosResponse> {
    return this.api.get(path, { params: { ...params } }).then((res) => res);
  }
  static search_customer(params: any): Promise<any> {
    return this.api.get(`${path}/search_customer`, { params: { ...params } }).then((res) => res);
  }
  static by_agent(params: any): Promise<any> {
    return this.api.get(`${path}/by_agent`, { params: { ...params } }).then((res) => res);
  }
  static findId(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`).then((res) => res);
  }
  static delete(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`).then((res) => res);
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body).then((res) => res);
  }
}